(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[809],{

/***/ 44282:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/delivery",
      function () {
        return __webpack_require__(4202);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ delivery; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.tsx + 13 modules
var Layout = __webpack_require__(78690);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/delivery/DeliverySection/DeliverySection.tsx






var DeliverySection = function(param) {
    var title = param.title, children = param.children, image = param.image, color = param.color, fixIcon = param.fixIcon;
    var classes = useStyles();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()(classes.leftSide, fixIcon && classes.fixIcon),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(classes[color], classes.line)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: image,
                        height: 71,
                        width: 71
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()(classes[color], classes.circle)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.rightSide,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        component: "h2",
                        className: classes.title,
                        children: title
                    }),
                    children
                ]
            })
        ]
    });
};
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        primary: {
            backgroundColor: theme.palette.primary.main
        },
        secondary: {
            backgroundColor: theme.palette.secondary.main
        },
        info: {
            backgroundColor: theme.palette.info.main
        },
        leftSide: (0,_define_property/* default */.Z)({
            position: "relative",
            minHeight: 150,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
            minWidth: 42,
            paddingTop: theme.spacing(1)
        }, theme.breakpoints.up("sm"), {
            marginLeft: theme.spacing(2),
            width: 71,
            minWidth: 71,
            paddingTop: 0
        }),
        fixIcon: {
            "& *:nth-child(2)": {
                marginLeft: "4px !important",
                overflow: "visible !important"
            }
        },
        container: (0,_define_property/* default */.Z)({
            display: "flex",
            gap: theme.spacing(2),
            marginBottom: theme.spacing(8)
        }, theme.breakpoints.up("sm"), {
            gap: theme.spacing(3)
        }),
        line: {
            height: "calc(100% - 30px)",
            width: 2,
            position: "absolute",
            top: 30,
            left: "50%",
            transform: "translate(-50%, 0)"
        },
        circle: {
            height: 13,
            width: 13,
            borderRadius: "50%"
        },
        rightSide: (0,_define_property/* default */.Z)({
            paddingTop: theme.spacing(1),
            "& ul": {
                paddingInlineStart: theme.spacing(3),
                margin: 0,
                marginBottom: theme.spacing(2)
            },
            "& li": {
                fontSize: "1.125rem"
            },
            "& h3": {
                marginBottom: theme.spacing(0.5)
            }
        }, theme.breakpoints.up("sm"), {
            paddingTop: theme.spacing(2.5)
        }),
        title: {
            fontSize: "1.5rem",
            marginBottom: theme.spacing(4)
        }
    };
});
/* harmony default export */ var DeliverySection_DeliverySection = (DeliverySection);

;// CONCATENATED MODULE: ./public/icons/notes.svg
/* harmony default export */ var notes = ({"src":"/_next/static/media/notes.19dac020.svg","height":381,"width":371});
;// CONCATENATED MODULE: ./public/icons/wallet.svg
/* harmony default export */ var wallet = ({"src":"/_next/static/media/wallet.456306d4.svg","height":537,"width":478});
;// CONCATENATED MODULE: ./public/icons/truck-shipped.svg
/* harmony default export */ var truck_shipped = ({"src":"/_next/static/media/truck-shipped.5c204d5a.svg","height":286,"width":404});
;// CONCATENATED MODULE: ./public/icons/return-box.svg
/* harmony default export */ var return_box = ({"src":"/_next/static/media/return-box.801c67c2.svg","height":800,"width":800});
// EXTERNAL MODULE: ./domain/constants/index.ts + 7 modules
var constants = __webpack_require__(74692);
;// CONCATENATED MODULE: ./components/delivery/Delivery.tsx









var Delivery = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            mb: 16,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DeliverySection_DeliverySection, {
                    title: "ЯК ЗРОБИТИ ЗАМОВЛЕННЯ?",
                    image: notes,
                    color: "primary",
                    fixIcon: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "li",
                                variant: "h5",
                                children: "Оформити замовлення на сайті можна ЦІЛОДОБОВО;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                component: "li",
                                variant: "h5",
                                children: [
                                    "Мінімальна сума замовленння - ",
                                    constants/* MIN_ORDER_PRICE */.Ks,
                                    " грн;"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "li",
                                variant: "h5",
                                children: "Після оформлення ми надішлемо повідомлення з номером вашого замовлення та реквізитами для оплати у Viber або SMS."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "li",
                                variant: "h5",
                                children: "Переглянути статус замовлення ви можете у вкладці “Відстежити замовлення”;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "li",
                                variant: "h5",
                                children: "Замовлення, оформлені після 19.00, опрацьовуються наступного дня."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliverySection_DeliverySection, {
                    title: "ЯК ОПЛАТИТИ?",
                    image: wallet,
                    color: "info",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h3",
                            children: "Карткою на сайті"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "li",
                                variant: "h5",
                                children: "Оплата онлайн через сервіс LiqPay одразу при оформленні замовлення (Visa, Mastercard, Apple Pay, Google Pay)."
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h3",
                            children: "Оплата на рахунок"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Після підтвердження замовлення ми надішлемо реквізити IBAN у Viber або SMS;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Замовлення потрібно оплатити протягом 24 годин з моменту підтвердження, в іншому разі бронювання товару скасовується."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h3",
                            children: "Оплата у відділенні Нової Пошти"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Обравши цей метод оплати, ви також сплачуєте комісію Нової Пошти за переказ коштів;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: [
                                        "Накладний платіж можливий при передоплаті ",
                                        constants/* ADVANCED_PAYMENT_FOR_CASH_ON_DELIVERY */.ye,
                                        " грн на карту для замовлень ",
                                        constants/* MIN_CASH_ON_DELIVERY_PRICE */.Pw,
                                        " грн та вище."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliverySection_DeliverySection, {
                    title: "ЯК ОТРИМАТИ ЗАМОВЛЕННЯ?",
                    image: truck_shipped,
                    color: "secondary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Замовлення відправляються протягом 2-3 днів з моменту підтвердження оплати;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Відправка замовлень відбувається в робочі дні з понеділка по п’ятницю;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Вартість та терміни доставки - згідно з тарифами Нової Пошти;"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h3",
                            children: [
                                "* при замовленні від ",
                                constants/* MIN_FREE_DELIVERY_PRICE */.e3,
                                " грн - доставка БЕЗКОШТОВНА"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DeliverySection_DeliverySection, {
                    title: "ЯК ПОВЕРНУТИ АБО ОБМІНЯТИ ТОВАР?",
                    image: return_box,
                    color: "primary",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Придбаний товар можна повернути або обміняти на інший протягом 14 днів при умові, що він не був у використанні та збережена оригінальна упаковка;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Доставку повернення оплачує покупець;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Кошти повертаємо банківським переказом протягом 7 робочих днів після отримання повернення;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "h5",
                                    children: "Якщо у товарі виявлено недолік - напишіть нам, і ми докладемо всіх зусиль, щоб швидко вирішити проблему."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h6",
                            component: "h3",
                            children: [
                                "* детальні умови повернення - у",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "/oferta.pdf",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "договорі оферти"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var delivery_Delivery = (Delivery);

;// CONCATENATED MODULE: ./pages/delivery.tsx






var DeliveryPage = function(param) {
    var pageMeta = param.pageMeta;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        pageMeta: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageMeta), {
            title: "Доставка та оплата"
        }),
        showTitleTag: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(delivery_Delivery, {})
    });
};
var __N_SSG = true;
/* harmony default export */ var delivery = (DeliveryPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,351,690,774,888,179], function() { return __webpack_exec__(44282); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);